<template>
  <div>
    <div class="d-flex justify-content-between">
      <h5 class="font-weight-bold">
        Monthly <span class="text-info">{{ mainPlan.name }}</span> Plan
      </h5>
      <b-button
        variant="outline-secondary"
        v-b-toggle.change-plan
        pill
        size="sm"
        >Change Plan</b-button
      >
    </div>
    <b-collapse id="change-plan" class="mt-2">
      <b-card>
        <b-table responsive :items="allPlans" :fields="fields">
          <template #cell(actions)="row">
            <b-button
              size="sm"
              :class="getButtonClass(row.item)"
              class="mr-1"
              :disabled="isUpdatable(row.item) || loading"
              @click="upgrade(row.item)"
            >
              {{ loading ? "upgrading..." : buttonLabel(row.item) }}
            </b-button>
          </template>
        </b-table>
      </b-card>
    </b-collapse>

    <div class="row p-5">
      <div
        v-for="(plan, i) in packages"
        :key="i"
        class="col-6 col-md-2 text-center"
      >
        <div class="col-circle">
          <h4 class="text-info">{{ plan.value }}</h4>
        </div>
        <h5 class="mt-2">{{ plan.name }}</h5>
      </div>
    </div>

    <h5 class="text-center">
      Next payment due:
      <span class="text-danger"
        >on or shortly after {{ purchase.due_date | to_date }}</span
      >
    </h5>

    <b-card class="mt-4">
      <b-table
        id="invoice"
        responsive
        :items="invoices"
        :fields="invoiceFields"
        :current-page="current_page"
      >
        <template #cell(actions)="row">
          <b-button
            size="sm"
            class="mr-1 btn-success"
            :disabled="row.item.status == 'paid'"
            @click="payInvoice(row.item)"
          >
            {{ invoiceBtnLabel(row.item) }}
          </b-button>
        </template>

        <template #cell(status)="row">
          <h1 class="p-2 badge" :class="invoiceStatusCls(row.item)">
            {{ row.item.status.toUpperCase() }}
          </h1>
        </template>

        <template #cell(created_at)="row">
          {{ row.item.created_at | moment_date }}
        </template>

        <template #cell(due_date)="row">
          {{ row.item.due_date | moment_date }}
        </template>
      </b-table>
      <b-pagination
        v-model="current_page"
        :total-rows="2"
        :per-page="5"
        aria-controls="invoice"
        class="float-right"
      >
      </b-pagination>
    </b-card>
    <payment-detail-modal ref="paymentDetailModal"></payment-detail-modal>
  </div>
</template>

<script type="text/ecmascript-6">
import { DISPATCH_UPGRADE } from "@/store/action-types";
import PaymentDetailModal from "@/components/PaymentDetailModal.vue";
import { FETCH_STATION_INFO } from "@/store/action-types";
import { mapState } from "vuex";

import { getCurrency } from "@/plugins/utils";
export default {
  name: "Billing",
  components: {
    PaymentDetailModal,
  },

  data() {
    return {
      pageTitle: "Billing",
      current_page: 1,
      fields: [
        "Name",
        "Diskspace",
        "Bandwidth",
        "Listeners",
        { key: "User", label: "DJs" },
        "Cost",
        { key: "actions", label: "Actions", thStyle: { minWidth: "140px" } },
      ],
      invoiceFields: [
        { key: "actions", label: "Action" },
        { key: "status", label: "Status" },
        {
          key: "reference",
          label: "Invoice #",
          thStyle: { minWidth: "110px" },
        },
        {
          key: "created_at",
          label: "Invoice Date",
          thStyle: { minWidth: "110px" },
        },
        { key: "due_date", label: "Due Date" },
        { key: "amount", label: "Amount" },
      ],
    };
  },

  computed: {
    ...mapState({
      errors: (state) => state.errors,
      loading: (state) => state.loading,
      onLine: (state) => state.auth.onLine,
    }),

    packages() {
      return [
        { name: "Diskspace", value: this.mainPlan?.benefits?.storage },
        { name: "Bandwidth", value: this.mainPlan?.benefits?.Bandwith },
        { name: "Listeners", value: this.mainPlan?.benefits?.Listeners },
        { name: "DJs", value: this.mainPlan?.benefits?.DJs },
        {
          name: "Plan Price",
          value: "$" + (this.mainPlan?.pricing?.usd || 0),
        },
        {
          name: "Total Price",
          value: "$" + (this.mainPlan?.pricing?.usd || 0),
        },
      ];
    },
  },

  methods: {
    getButtonClass(item) {
      return item.Name == this.mainPlan.name ? "btn-success" : "btn-info";
    },

    isUpdatable(item) {
      const currentPlan = this.mainPlan?.pricing?.usd || 0;
      const CostNumber = item.CostNumber;

      if (
        Number(CostNumber) == Number(currentPlan) ||
        Number(CostNumber) < Number(currentPlan)
      ) {
        return true;
      }

      return false;
    },

    buttonLabel(item) {
      // console.log(item);
      const currentPlan = this.mainPlan?.pricing?.usd || 0;
      const CostNumber = item.CostNumber;
      //  console.log({'current':currentPlan,'cost':CostNumber});

      if (Number(CostNumber) > Number(currentPlan)) {
        return "Upgrade Plan";
      } else if (Number(CostNumber) < Number(currentPlan)) {
        return "Downgrade Plan";
      }
      return "Current Plan";
    },

    invoiceStatusCls(item) {
      return item.status == "paid" ? "badge-success" : "badge-warning";
    },

    invoiceBtnLabel(item) {
      const status = item.status;
      // console.log(status);

      if (status === "paid") {
        return "View";
      }
      return "Pay";
    },

    async upgrade(item) {
      swal
        .fire({
          text: `Are you sure you want to upgrade`,
          confirmButtonText: "Upgrade",
          confirmButtonColor: "#e64942",
          showCancelButton: true,
          focusCancel: true,
        })
        .then(async (result) => {
          if (result.value) {
            console.log(item);
            await this.$store.dispatch(DISPATCH_UPGRADE, {
              id: this.stationId,
              plan_id: item.id,
            });

            this.$store.dispatch(FETCH_STATION_INFO, {
              id: this.stationId,
              repeat: false,
            });
          }
        });
    },

    payInvoice(item) {
      this.$refs.paymentDetailModal.create(item.id);
    },
  },

  mounted() {
    this.$eventHub.$on("trial", (e) => {
      this.$store.dispatch(FETCH_STATION_INFO, {
        id: this.stationId,
        repeat: false,
      });
    });
  },
};
</script>

<style scoped>
.col-circle {
  border: 1px solid #6f42c1;
  padding: 20px;
  height: 120px;
  line-height: 120px;
  width: 120px;
  display: flex; /* or inline-flex */
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.tdWidth {
  max-width: 40%;
}

/* /deep/ .table > tbody > tr > td {
  max-width: 300px;
} */
</style>
